import React, { MouseEventHandler, useContext } from 'react';
import { BKJButton, BKJFileInput } from '@bookjane2/bookjane-design-library';
import { BKJSideModalFooter } from 'components/BKJSideModalFooter';
import { Flex } from 'components/Flex';

import {
  CSVBorderHeaderStyle,
  H3,
  TeamMemberCSVWrapper,
  LocationHeader,
  LocationName,
  DownloadHeader,
  UploadHeader,
} from 'components/InviteTeamMembersByCSVModal/views/ImportViaSpreadsheet/TeamMemberCSVView.styled';

import { FC } from 'react';
import {
  TeamMemberCSVViewFormProvider,
  useTeamMemberCSVViewFormContext,
} from 'components/InviteTeamMembersByCSVModal/views/ImportViaSpreadsheet/TeamMemberCSVView.form.context';
import { useTranslation } from 'hooks/useTranslation';
import { TeamMemberPageContext } from 'pages/TeamMembers/Internal/TeamMemberPage.context';

export const CSVView: FC = () => {
  const { onDownload, values, onChange, fieldErrors, onSubmit, isSubmitting } =
    useTeamMemberCSVViewFormContext();
  const {
    values: { location },
  } = useContext(TeamMemberPageContext);
  const locationName = location?.label;
  const { t } = useTranslation();

  return (
    <Flex
      flexDirection="column"
      justifyContent="flex-start"
      alignItems="flex-start"
      width="100%"
      flexGrow={1}
      borderTop={CSVBorderHeaderStyle}
    >
      <Flex flexDirection="column" padding="32px 40px 15px" gap="32px">
        <H3>{t('team_member:IMPORT_VIA_SPREADSHEET')}</H3>
        <TeamMemberCSVWrapper>
          <LocationHeader>{t('team_member:LOCATION')}</LocationHeader>
          <LocationName>{locationName}</LocationName>
        </TeamMemberCSVWrapper>
        <TeamMemberCSVWrapper>
          <DownloadHeader>1. {t('team_member:DOWNLOAD_SPREADSHEET')}</DownloadHeader>
          <LocationName>{t('team_member:FILL_IN_TEAM_MEMBER_DATA_IN_SPREADSHEET')}</LocationName>
        </TeamMemberCSVWrapper>
        <BKJButton variant="PurpleOutlined" width="180px" onClick={onDownload} type="button">
          {t('team_member:DOWNLOAD')}
        </BKJButton>
        <TeamMemberCSVWrapper>
          <UploadHeader>2. {t('team_member:UPLOAD_SPREADSHEET')}</UploadHeader>
          <LocationName>{t('team_member:SELECT_CSV_OR_XLS_FILE_AND_UPLOAD_IT')}</LocationName>
        </TeamMemberCSVWrapper>
        <div style={{ width: '50%' }}>
          <BKJFileInput
            value={values?.csv}
            name="csv"
            onChange={onChange}
            accept=".csv,.xlsx"
            error={fieldErrors?.csv}
          />
        </div>
      </Flex>

      <Flex height="100%"></Flex>
      <BKJSideModalFooter justifyContent="space-between" flexDirection="row-reverse">
        <BKJButton
          variant="PurpleOutlined"
          width="180px"
          disabled={!values?.csv}
          isLoading={isSubmitting}
          onClick={onSubmit as unknown as MouseEventHandler<HTMLButtonElement>}
          type="button"
        >
          {t('team_member:IMPORT')}
        </BKJButton>
      </BKJSideModalFooter>
    </Flex>
  );
};

export const TeamMemberCSVView: FC = () => {
  return (
    <TeamMemberCSVViewFormProvider>
      <CSVView />
    </TeamMemberCSVViewFormProvider>
  );
};
